import React from 'react';

const ExclamationMark = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#F0F0F1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15ZM10.6 7.66122V10.8395H9.4V7.66122H10.6ZM10.6 11.5082V12.8142H9.4V11.5082H10.6Z"
      fill="#777F8E"
    />
  </svg>
);

export default ExclamationMark;
